export default __webpack_public_path__ + "static/media/-1-1709723055050.19141805.png";